
import * as _ from "lodash";

export function importXml(params: any, bpmnjs: any, eventBus: any, elementRegistry: any) {
    return {
        args: [
            params.string("xml")
        ],
        exec: (xml: any) => {
            bpmnjs.importXML(xml, (err: { message: string, stack: string }) => {
                /*
                    Modified id generation from from https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
                */
                function makeid(prefix: string, elements: BpmnJsElement[]) {
                    let idText: string;
                    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                    do {
                        idText = prefix;
                        for (let i = 0; i < 10; i++) {
                            idText += possible.charAt(Math.floor(Math.random() * possible.length));
                        }
                    } while (elements.find((e) => e.id === idText) != null);
                    return idText;
                }
                const modeler = bpmnjs.injector._instances["modeling"];
                const factory = bpmnjs.injector._instances["bpmnFactory"];
                const variableNamingRegexp = /^[a-zA-Z_][a-zA-Z_0-9]*/; // there's more valid combinations, but if we have a false positive for renaming, that's not the end of the world

                const result = { type: "FRENDS.elements.imported", successful: false, elements: [], errorMessage: null, stackTrace: null } as BpmnImportResult;
                if (!err) {
                    result.successful = true;
                    result.elements = _.map(elementRegistry._elements, (e) => (e as any).element);
                    for (const element of result.elements) {
                        const validName = element.id.match(variableNamingRegexp);
                        if (element.type.startsWith("bpmn:") && (!validName || validName[0] !== element.id)) {
                            // the following will trigger a single update event, so for every rename the editor will go trough an update cycle. Since this only happens on import, that should be fine.
                            const newId = makeid((element.type || "").replace("bpmn:", ""), result.elements);
                            modeler.updateProperties(element, {id: newId});
                        }
                    }
                } else {
                    result.errorMessage = err.message;
                    result.stackTrace = err.stack;
                }
                // Fire an import event and let the BpmnEditor handle the result and potential errors:
                eventBus.fire("FRENDS.elements.imported", result);
            });

        }
    };
}
importXml.$inject = ["cli._params", "bpmnjs", "eventBus", "elementRegistry"];
